<template>
  <div>
    <el-form ref="forceCloseFormRef" :model="forceCloseFormData" label-position="top">
      <el-row>
        <!--发票密钥-->
        <el-col :span="24">
          <el-form-item
            :label="$t('mdfeTranslate.InvoiceSecretKey')"
            prop="mdfeKey"
            :rules="{ required: true, validator: enterNumber, trigger: ['blur','change'] }"
          >
            <el-input
              v-model="forceCloseFormData.mdfeKey"
              :placeholder="$t('GlobalSetObj.pleaseInput')"
            />
          </el-form-item>
        </el-col>
        <!--协议编号-->
        <el-col :span="24">
          <el-form-item
            :label="$t('mdfeTranslate.AgreementNumber')"
            prop="protocolNumber"
            :rules="{ required: true, validator: enterNumber, trigger: ['blur','change'] }"
          >
            <el-input
              v-model="forceCloseFormData.protocolNumber"
              :placeholder="$t('GlobalSetObj.pleaseInput')"
            />
          </el-form-item>
        </el-col>
        <!--公司税号-->
        <el-col :span="24">
          <el-form-item
            :label="$t('mdfeTranslate.CompanyTaxNumber')"
            prop="cnpj"
            :rules="{ required: true, message: $t('placeOrder.pleaseChoose'), trigger: ['blur','change'] }"
          >
            <el-select
              v-model="forceCloseFormData.cnpj"
              :placeholder="$t('placeOrder.pleaseChoose')"
              class="formTable"
              clearable
              filterable
              remote
              reserve-keyword
              :remote-method="getCompanyList"
              style="width: 100%"
              @visible-change="handleCompanyList"
            >
              <el-option
                v-for="item in companyList"
                :key="item.id"
                :label="item.fantasyName ? item.fantasyName : item.name"
                :value="item.cnpj"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!--结束州-->
        <el-col :span="24">
          <el-form-item
            :label="$t('mdfeTranslate.EndState')"
            prop="endUfCode"
            :rules="{ required: true, message: $t('placeOrder.pleaseChoose'), trigger: ['blur','change'] }"
          >
            <el-select
              v-model="forceCloseFormData.endUfCode"
              :placeholder="$t('placeOrder.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
              @change="getMidProvinceChange(forceCloseFormData.endUfCode)"
            >
              <el-option
                v-for="list in senderStateList"
                :key="list.stateCode"
                :label="list.stateNameZh + '（' + list.stateNamePu + '）'"
                :value="list.stateCodeNumber"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!--结束城市-->
        <el-col :span="24">
          <el-form-item
            :label="$t('mdfeTranslate.EndCity')"
            prop="endCityCode"
            :rules="{ required: true, message: $t('placeOrder.pleaseChoose'), trigger: ['blur','change'] }"
          >
            <el-select
              v-model="forceCloseFormData.endCityCode"
              :placeholder="$t('placeOrder.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="list in senderCityList"
                :key="list.cityCodeNumber"
                :label="list.cityNameZh + '（' + list.cityNamePu + '）'"
                :value="list.cityCodeNumber"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { forceCloseCteInvoice, getCompanyOptions, getMidCity, getMidProvince } from '@/api/invoiceCenter';

export default {
  name: 'ForceClose',
  data() {
    const enterNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
      } else {
        if (!/^[0-9]+$/.test(value)) {
          return callback(new Error(this.$t('mdfeTranslate.OnlyNumbersCanBeEntered'))); // 只能输入数字
        } else {
          return callback();
        }
      }
    };
    return {
      forceCloseFormData: {
        mdfeKey: '',
        protocolNumber: '',
        cnpj: '',
        endUfCode: '',
        endCityCode: ''
      },
      companyList: [],
      senderStateList: [],
      senderCityList: [],
      enterNumber
    };
  },
  created() {
    this.getAddress();
  },
  methods: {
    // 获取公司选项
    getCompanyList(name = '') {
      const param = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          name
        }
      };
      getCompanyOptions(param).then(res => {
        if (res.code === 200) {
          this.companyList = res.data.records;
        }
      });
    },
    // 获取公司列表
    handleCompanyList(val) {
      if (val) {
        this.getCompanyList();
      }
    },
    // 获取起点和目的地选项
    getAddress() {
      getMidProvince().then((res) => {
        if (res.code === 200) {
          this.senderStateList = res.data;
        }
      });
    },
    // 州选项变化
    getMidProvinceChange() {
      this.senderCityList = [];
      this.forceCloseFormData.endCityCode = '';
      if (this.forceCloseFormData.endUfCode) {
        const stateCode = this.senderStateList.filter(item => item.stateCodeNumber === this.forceCloseFormData.endUfCode);
        console.log(stateCode[0].stateCode, '===stateCode');
        getMidCity(stateCode[0].stateCode).then(res => {
          if (res.code === 200) {
            this.senderCityList = res.data;
          }
        });
      }
    },
    // 强制关闭提交
    forceCloseSubmit() {
      this.$refs.forceCloseFormRef.validate(valid => {
        if (valid) {
          this.$confirm(this.$t('mdfeTranslate.AreYouSureYouWantToForceClose'), this.$t('collectionCenter.tips'), {
            confirmButtonText: this.$t('collectionCenter.confirm'), // '确定',
            cancelButtonText: this.$t('collectionCenter.cancel'), // '取消',
            type: 'warning'
          }).then(() => {
            forceCloseCteInvoice(this.forceCloseFormData).then(res => {
              if (res.code === 200) {
                if (res.data.success) {
                  this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded')); // 操作成功
                  this.$emit('forceCloseSuccess');
                } else {
                  this.$message.error(res.data.failureReason || this.$t('mdfeTranslate.OperationFailed')); // 操作失败
                }
              }
            });
          });
        }
      });
    }
  }
};
</script>
<style scoped>

</style>
